<ng-container *ngIf="!fromGrid && product$ | async as product; else gridDisplay">
  <div class="product-promotions" *ngIf="product.potentialPromotions?.length > 0">
    <ng-container *ngFor="let promo of product.potentialPromotions">
      <div class="product-promo-wrapper" *ngIf="promo?.description && promo?.description !== ''">
        <div class="product-promo">
          <div class="promo-block" *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
            <app-tooltip-text
              class="promo-truncate"
              [tooltipContent]="concatText(promo.description, 'product.promo' | cxTranslate)"
              [content]="promo.description"
              [promotionLocation]="'PDP'"
              placement="right"
              [charactersLimit]="34"
            >
            </app-tooltip-text>
            <app-tooltip-icon
              *ngIf="tooltipIconConfig?.enabled"
              [matIconName]="tooltipIconConfig?.matIconName"
              [matIconTheme]="tooltipIconConfig?.matIconTheme"
              placement="bottom-right"
              [size]="tooltipIconConfig?.size"
              [tooltipContent]="'tooltip.promotion' | cxTranslate"
              [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
            ></app-tooltip-icon>
          </div>
        </div>
      </div>
      <br />
    </ng-container>
  </div>
</ng-container>
<ng-template #gridDisplay>
  <ng-container *ngIf="fromGrid && promProductsFromGrid$ | async as productss">
    <div class="product-promotions" *ngIf="productss.potentialPromotions?.length > 0">
      <ng-container *ngFor="let promo of productss.potentialPromotions">
        <div class="product-promo-wrapper" *ngIf="promo?.description && promo?.description !== ''">
          <div class="product-promo">
            <div class="promo-block" *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
              <app-tooltip-text
                class="promo-truncate"
                [tooltipContent]="concatText(promo.description, 'product.promo' | cxTranslate)"
                [content]="promo.description"
                [promotionLocation]="'PDP'"
                placement="right"
                [charactersLimit]="34"
              >
              </app-tooltip-text>
              <app-tooltip-icon
                *ngIf="tooltipIconConfig?.enabled"
                [matIconName]="tooltipIconConfig?.matIconName"
                [matIconTheme]="tooltipIconConfig?.matIconTheme"
                placement="bottom-right"
                [size]="tooltipIconConfig?.size"
                [tooltipContent]="'tooltip.promotion' | cxTranslate"
                [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
              ></app-tooltip-icon>
            </div>
          </div>
          <br />
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
